import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';

function useSSRGeneratorNew(generatorId: string) {
  const { data: elasticData, isError: elasticIsError } = useQuery(
    ['generator-retrieve', generatorId],
    () => BackendService.instance.generators.retrieve(generatorId),
    {
      staleTime: 1000 * 60 * 5,
    },
  );
  return {
    generator: elasticData,
    isError: elasticIsError,
  };
}

export default useSSRGeneratorNew;
